export const COLUMN_SIZES = {
  XXS: 20,
  XS: 100,
  XS2: 105,
  XS3: 110,
  SM: 150,
  SM2: 135,
  SM3: 170,
  MD: 200,
  MD2: 250,
  MD3: 230,
  LG: 300,
};

export const COLUMN_MARGIN = 35;

export const HEADER_CELL_TYPES = {
  FILTER: 'filter',
  NORMAL: 'normal',
};

export const PAGINATION_ARROWS = {
  RIGHT: 'right',
  LEFT: 'left',
};

export const PAGINATION_TYPES = {
  INFINITE_SCROLL: 'infinite-scroll',
  NORMAL: 'normal',
};
